import {
  Box,
  Typography,
  Button,
  Paper,
  Popper,
  ClickAwayListener,
  Divider,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

const FilterDropdown = ({
  anchorEl,
  open,
  onClose,
  activeFilters,
  onStatusFilterChange,
  onDueDateFilterChange,
  onClearFilters,
  statusOptions,
  dueDateOptions,
}) => {
  const activeFilterCount =
    activeFilters.status.length + activeFilters.dueDate.length;

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-end"
      sx={{ zIndex: 1300 }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Paper
          elevation={8}
          sx={{
            mt: 1,
            p: 2.5,
            borderRadius: 3,
            minWidth: 280,
            boxShadow: "0 10px 40px rgba(0, 0, 0, 0.15)",
            border: "1px solid rgba(0, 0, 0, 0.05)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              sx={{ fontWeight: 700, fontSize: 15, color: "#1E293B" }}
            >
              Filters
            </Typography>
            {activeFilterCount > 0 && (
              <Button
                onClick={onClearFilters}
                sx={{
                  textTransform: "none",
                  fontSize: 12,
                  fontWeight: 500,
                  color: "#EF4444",
                  p: 0,
                  minWidth: "auto",
                  "&:hover": {
                    bgcolor: "transparent",
                    color: "#DC2626",
                  },
                }}
              >
                Clear all
              </Button>
            )}
          </Box>

          {/* Status Filter */}
          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 600,
                color: "#64748B",
                textTransform: "uppercase",
                mb: 1,
              }}
            >
              Status
            </Typography>
            <FormGroup>
              {statusOptions.map((status) => (
                <FormControlLabel
                  key={status}
                  control={
                    <Checkbox
                      checked={activeFilters.status.includes(status)}
                      onChange={() => onStatusFilterChange(status)}
                      size="small"
                      sx={{
                        color: "#CBD5E1",
                        "&.Mui-checked": {
                          color: "#7C3AED",
                        },
                      }}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: 13, color: "#475569" }}>
                      {status}
                    </Typography>
                  }
                  sx={{ ml: 0, mb: 0.5 }}
                />
              ))}
            </FormGroup>
          </Box>

          <Divider sx={{ my: 1.5 }} />

          {/* Due Date Filter */}
          <Box>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 600,
                color: "#64748B",
                textTransform: "uppercase",
                mb: 1,
              }}
            >
              Due Date
            </Typography>
            <FormGroup>
              {dueDateOptions.map((dueDate) => (
                <FormControlLabel
                  key={dueDate}
                  control={
                    <Checkbox
                      checked={activeFilters.dueDate.includes(dueDate)}
                      onChange={() => onDueDateFilterChange(dueDate)}
                      size="small"
                      sx={{
                        color: "#CBD5E1",
                        "&.Mui-checked": {
                          color: "#7C3AED",
                        },
                      }}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: 13, color: "#475569" }}>
                      {dueDate}
                    </Typography>
                  }
                  sx={{ ml: 0, mb: 0.5 }}
                />
              ))}
            </FormGroup>
          </Box>
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

export const FilterButton = ({ onClick, activeFilterCount }) => (
  <Button
    onClick={onClick}
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      height: 36,
      px: 2,
      borderRadius: "999px",
      textTransform: "none",
      fontSize: 13,
      fontWeight: 600,
      color: "#7C3AED",
      border: "1.5px solid #7C3AED",
      backgroundColor: "#FFFFFF",
      "&:hover": {
        backgroundColor: "#F5F3FF",
        borderColor: "#6D28D9",
      },
    }}
  >
    <FilterListIcon sx={{ fontSize: 18 }} />
    Filter
    {activeFilterCount > 0 && (
      <Box
        sx={{
          ml: 0.5,
          width: 20,
          height: 20,
          borderRadius: "50%",
          backgroundColor: "#7C3AED",
          color: "#FFFFFF",
          fontSize: 11,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {activeFilterCount}
      </Box>
    )}
  </Button>
);

export default FilterDropdown;
